module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgScr,
      "alt": " "
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "signIn"
  }, [(_vm.wall) ? _c('h2', [_vm._v(_vm._s(_vm.wall.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.wall) ? _c('div', {
    staticClass: "sign"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.name != 0),
      expression: "wall.name != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "maxlength": "6",
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.mobile != 0),
      expression: "wall.mobile != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "maxlength": "11",
      "type": "tel",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.mail != 0),
      expression: "wall.mail != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    attrs: {
      "maxlength": "30",
      "type": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other1),
      expression: "wall.other1"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other1),
      expression: "other1"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other1
    },
    domProps: {
      "value": (_vm.other1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other2),
      expression: "wall.other2"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other2),
      expression: "other2"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other2
    },
    domProps: {
      "value": (_vm.other2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other3),
      expression: "wall.other3"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other3),
      expression: "other3"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other3
    },
    domProps: {
      "value": (_vm.other3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other3 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "buttom",
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v("签到")])]) : _c('div', {
    staticClass: "sign"
  }, [_c('a', {
    staticClass: "buttom",
    on: {
      "click": _vm.liveing
    }
  }, [_vm._v("进入直播间")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42a01267"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/signIn.vue
// module id = 484
// module chunks = 0